export const COOKIE_NAMES = {
  // Authentication cookies
  TEAM_NAME: 'team_name',
  ACCESS_TOKEN: 'access_token',
  USERNAME: 'username',
  KEYCLOAK_ACCESS_TOKEN: 'keycloak_access_token',
  NO_TENANT_ID: 'no_fly_tenant_id',
  USER_TEAMS: 'user_teams',

  //Signup cookies
  INVITATION_TOKEN_ID: 'token',
  INVITATION_TEAM: 'team',
  INVITATION_FLOW: 'invitation_flow',
  REGISTRATION_TOKEN: 'registration_token',
} as const;

export type CookieName = (typeof COOKIE_NAMES)[keyof typeof COOKIE_NAMES];

// Cookie configuration for OIDC
export const COOKIE_CONFIG = {
  // Default cookie options
  DEFAULT_OPTIONS: {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax' as const,
  },

  // Session cookies (expire when browser closes)
  SESSION: {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax' as const,
  },

  REGISTRATION_TOKEN: {
    path: '/',
    secure: true,
    sameSite: 'lax' as const,
    maxAge: 24 * 60 * 60, // 1 day in seconds
    // TODO: Is this correct expiration time
  },
} as const;
